import React from 'react';
import { SectionHeading, SpecSection } from './SectionHeading';
import { TypeAndSound } from './TypeAndSound';
import { LevelBadge } from '../ui/LevelBadge';
import { accentProposals, dayparts } from '../../data/atmosphere';
import { houseModes } from '../../data/houseModes';
import { useSpecSettings } from '../../contexts/SpecSettingsContext';
import { rgbChannels } from '../../utils/color';
export function AtmosphereSection() {
  const {
    accent
  } = useSpecSettings();
  return <SpecSection id="sfeer" data-id="element-902" data-mp="113w4c8hmzcht">
      <SectionHeading id="sfeer" index={4} title="Sfeer" intro="Donkere, diepe achtergronden met een heel zachte gloed achter Anna. De kleur van die gloed volgt de tijd van de dag en de huismodus." data-id="element-903" data-mp="1132x76ermkz5" />

      <div className="mt-14 grid grid-cols-2 gap-4 lg:grid-cols-4" data-id="element-904" data-mp="s9pw3h6jsd1z">
        {dayparts.map(d => <figure key={d.id} data-id="element-905" data-mp="1fzk49lfx9dfw">
            <div className="relative aspect-[4/3] overflow-hidden rounded-2xl border border-white/[0.06]" style={{
          background: `radial-gradient(circle at 50% 55%, ${d.glow}59 0%, ${d.glow}1f 30%, transparent 66%), #06080B`
        }} data-id="element-906" data-mp="1ksn1c3jwr50u">
              <span aria-hidden className="absolute left-1/2 top-[55%] h-3 w-3 -translate-x-1/2 -translate-y-1/2 rounded-full" style={{
            backgroundColor: d.id === 'nacht' ? '#3A4252' : d.glow
          }} data-id="element-907" data-mp="2m40njf3zsbww" />
              {d.id === 'nacht' && <span className="absolute left-4 top-3 font-display text-[22px] font-light tabular-nums text-ink-muted" data-id="element-908" data-mp="39x94b9cmihqp">22:40</span>}
            </div>
            <figcaption className="mt-3" data-id="element-909" data-mp="3iut92s9p2w62">
              <p className="text-[16px] font-semibold text-ink" data-id="element-910" data-mp="3dx023x0khy4q">
                {d.label} <span className="font-normal text-ink-muted" data-id="element-911" data-mp="3dxsxk1u2t17k">· {d.hours}</span>
              </p>
              <p className="mt-0.5 text-[14px] text-ink-soft" data-id="element-912" data-mp="1oibojsg8qa54">{d.note}</p>
            </figcaption>
          </figure>)}
      </div>

      <dl className="mt-10 grid gap-x-8 gap-y-3 border-t border-white/[0.07] pt-6 sm:grid-cols-2 lg:grid-cols-5" data-id="element-913" data-mp="3jlht3ujaa4fk">
        {houseModes.map(m => <div key={m.id} data-id="element-914" data-mp="3okuqvabp0vwx">
            <dt className="text-[14px] font-semibold text-ink" data-id="element-915" data-mp="3om5vfccyq7p3">{m.id}</dt>
            <dd className="text-[14px] text-ink-muted" data-id="element-916" data-mp="3thupj067qwe0">Gloed: {m.glow}</dd>
          </div>)}
      </dl>

      <div className="mt-20" data-id="element-917" data-mp="1dimycm6anmh">
        <h3 className="text-[20px] font-semibold text-ink" data-id="element-918" data-mp="6ezlw2l3k00f">Signatuuraccent: twee voorstellen</h3>
        <p className="mt-1 text-[15px] text-ink-muted" data-id="element-919" data-mp="bdja69n5xnvy">
          Eén accent voor het hele product. Glas alleen voor zwevende kaarten, met fijne lichtranden van 1px.
        </p>
        <div className="mt-8 grid gap-6 lg:grid-cols-2" data-id="element-920" data-mp="g6m3qhrxwxc5">
          {accentProposals.map(a => {
          const active = a.id === accent;
          return <div key={a.id} className="relative overflow-hidden rounded-3xl border border-white/[0.07] bg-night-900 p-6 sm:p-8" style={{
            ['--accent' as string]: rgbChannels(a.hex)
          } as React.CSSProperties} data-id="element-921" data-mp="p6ils0jtqxy8">
                <div aria-hidden className="absolute -right-24 -top-24 h-72 w-72" style={{
              background: `radial-gradient(closest-side, ${a.hex}33, transparent)`
            }} data-id="element-922" data-mp="29mywheb8iocq" />
                <div className="relative flex items-start justify-between gap-4" data-id="element-923" data-mp="20o4t953eezq7">
                  <div data-id="element-924" data-mp="2xbj6yuho4ikj">
                    <p className="text-[20px] font-semibold text-ink" data-id="element-925" data-mp="2xc19u9yu5v1f">{a.name}</p>
                    <p className="mt-0.5 font-mono text-[13px] text-ink-muted" data-id="element-926" data-mp="2tbr6z66cbkqs">{a.hex}</p>
                  </div>
                  {active && <span className="whitespace-nowrap rounded-full bg-white/[0.08] px-3 py-1 text-[12px] font-medium text-ink-soft" data-id="element-927" data-mp="2jlfq6j1k5h2h">
                      Actief op deze pagina
                    </span>}
                </div>
                <p className="relative mt-4 max-w-md text-[15px] leading-relaxed text-ink-soft" data-id="element-928" data-mp="3c9bkxi7kgywm">{a.note}</p>
                <div className="relative mt-8 flex flex-wrap items-center gap-4" data-id="element-929" data-mp="2vt12xosohpyu">
                  <span aria-hidden className="h-10 w-10 rounded-full" style={{
                backgroundColor: a.hex
              }} data-id="element-930" data-mp="30uqd7282tzlv" />
                  <LevelBadge level="tenzijBezwaar" data-id="element-931" data-mp="2mv7ibb4a0kri" />
                  <span className="text-[13px] font-semibold text-accent underline decoration-accent/40 underline-offset-4" data-id="element-932" data-mp="2rspjgfc1xvoy">Waarom?</span>
                  <span className="inline-flex h-10 items-center rounded-full bg-accent px-4 text-[14px] font-semibold text-night-950" data-id="element-933" data-mp="3fjmod85fjsqp">
                    Schuif om te bevestigen
                  </span>
                </div>
              </div>;
        })}
        </div>
      </div>

      <TypeAndSound data-id="element-934" data-mp="3aqthadmho8bg" />
    </SpecSection>;
}